import { SET_AUTH } from '@actions/auth'

const defaultState = {
  data: null,
}

const authReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_AUTH: {
      const { data } = action
      return {
        data,
      }
    }
    default:
      return state
  }
}

export default authReducer
